try {
  var url_string = (window.location.href).toLowerCase();
  var url = new URL(url_string);
  var step = url.searchParams.get("step");
  if (step === '2') {
    document.getElementById("md-step1").classList.add("active");
    document.getElementById("md-step1").classList.add("done");
    document.getElementById("md-step2").classList.add("active");
    document.getElementById('step1').style.display='none';
    document.getElementById('step2').style.display='block';
  }
  else if (step === '3') {
    document.getElementById("md-step1").classList.add("active");
    document.getElementById("md-step1").classList.add("done");
    document.getElementById("md-step2").classList.add("done");
    document.getElementById("md-step2").classList.add("active");
    document.getElementById("md-step3").classList.add("active");
    document.getElementById('step1').style.display='none';
    document.getElementById('step2').style.display='none';
    document.getElementById('step3').style.display='block';
  }
  else if (step === '4') {
    document.getElementById("md-step1").classList.add("active");
    document.getElementById("md-step1").classList.add("done");
    document.getElementById("md-step2").classList.add("done");
    document.getElementById("md-step2").classList.add("active");
    document.getElementById("md-step3").classList.add("active");
    document.getElementById("md-step3").classList.add("done");
    document.getElementById("md-step4").classList.add("active");
    document.getElementById('step1').style.display='none';
    document.getElementById('step2').style.display='none';
    document.getElementById('step3').style.display='none';
    document.getElementById('step4').style.display='block';
  }
  else if (step === '5') {
    document.getElementById("md-step1").classList.add("active");
    document.getElementById("md-step1").classList.add("done");
    document.getElementById("md-step2").classList.add("done");
    document.getElementById("md-step2").classList.add("active");
    document.getElementById("md-step3").classList.add("active");
    document.getElementById("md-step3").classList.add("done");
    document.getElementById("md-step4").classList.add("active");
    document.getElementById('step1').style.display='none';
    document.getElementById('step2').style.display='none';
    document.getElementById('step3').style.display='none';
    document.getElementById('step4').style.display='none';
    document.getElementById('step5').style.display='block';
  }
  else {
    document.getElementById('step1').style.display='block';
    document.getElementById('step2').style.display='none';
    document.getElementById('step3').style.display='none';
  }
} catch (err) {
  console.log("Issues with Parsing URL Parameter's - " + err);
}

// <script type="application/javascript">
jQuery(document).ready(function () {

  $("#files").change(function () {});
  document.addEventListener("DOMContentLoaded", function () {

    if (jQuery("#where-did-you-buy").val() == "Case-mate.com" && jQuery("#which-country").val() == "US") {
      jQuery(".customer_details").show();
    } else {
      jQuery(".customer_details").hide();
    }
  });
  jQuery("#reason-for-claim").change(function () {
    if (jQuery(this).val() == "Other") {
      jQuery(".reason").show();
    } else {
      jQuery(".reason").hide();
    }
     console.log('reason-change');
  });

  jQuery("#reason-for-claim").change(function () {
      jQuery(".customer_details").show();
  });

  $(".get_details").click(function () {
    if ($("#order-id").val() == "" || $("#email-id").val() == "" || $("#product_images").val() == "") {
      $(".errormsg").html("Please enter order number, email address, and upload image to proceed.");
      return false;
    }
    $(".loader").show();

    $.post("https://shopifywarranty.case-mate.com/fetch_order.php", {
      orderid: $("#order-id").val(),
      cemail: $("#email-id").val(),
      oid: $("#order-id").val(),
      cemail: $("#email-id").val(),
      whatdidyou: $("#what-did-you-buy").val(),
      wheredidyou: $("#where-did-you-buy").val(),
      lastname: $("#last-name").val(),
      product_images: $("#product_images").val()

    }, function (data, status) {
      $(".loader").hide();
      $(".product_details").html(data);
      $(".product_details").show();
      $(".errormsg").html(" ");
      $(".errormsg").hide();
      $(".get_details").hide();
      $(".g-recaptcha").show();
      $(".submit_link").show();
    });
    return false;
  });


  $(document).on("click", ".radio", function (event) {
    $(".singleproduct").removeClass("blueborder");
    $(this).closest(".singleproduct").addClass("blueborder");
  });
  $(".submit_link").click(function () {


    // reCaptcha varification
    $(".g-recaptcha-msg").hide();
    var gresponse = grecaptcha.getResponse();
    if (gresponse.length == 0) {
      // reCaptcha not verified
      $(".g-recaptcha-msg").show();
      $(".g-recaptcha-msg").html("Please verify you are human!");
      evt.preventDefault();
      return true;
    }
    // end reCaptcha varification


    var variantid = $("input[name=warrantyproduct]:checked", "#warranty_form").val();
    var customerid = $("input[name=warrantyproduct]:checked", "#warranty_form").attr("cust-id");
    var orderdate = $("input[name=warrantyproduct]:checked", "#warranty_form").attr("var-order-date");
    var productsku = $("input[name=warrantyproduct]:checked", "#warranty_form").attr("var-sku");
    var productid = $("input[name=warrantyproduct]:checked", "#warranty_form").attr("var-product-id");
    var producttitle = $("input[name=warrantyproduct]:checked", "#warranty_form").attr("prod-title");
    var productprice = $("input[name=warrantyproduct]:checked", "#warranty_form").attr("var-price");

    /* if($("#where-did-you-buy").val() == "Case-mate.com" && $("#which-country").val() == "US"){
      if($("#order-id").val() == "" || $("#email-id").val() == "" || $("#product_images").val() == "" || variantid == ""){
        $(".errormsg").html("Please enter order details and upload image. Then, click &quot;Get Order Details&quot; to select product."); 
        $(".errormsg").show();
        return false;
       }  
      else{
        if(variantid == "" || variantid == null){
          $(".errormsg").html("Please select product for warranty claim."); 
             $(".errormsg").show();
            return false;
        }
        }
    }
    else{
      if($("#which-country").val() == "Other Country"){

        window.location.href = 'https://support.case-mate.com/hc/en-us/requests/new';
      }
      else{
          if($("#which-country").val() == "US" && $("#where-did-you-buy").val() != "Case-mate.com" && $("#what-did-you-buy").val() == 'Phone Cases')
        {
          window.location.href = '/pages/retail-warranty?type=cases';
        }
        if($("#which-country").val() == "US" && $("#where-did-you-buy").val() != "Case-mate.com" && $("#what-did-you-buy").val() == 'Screen Protectors')
        {
          window.location.href = '/pages/retail-warranty?type=screen_protector';
        }
      }
    }*/

    if ($("#which-country").val() == "Other Country") {
      window.location.href = "https://support.case-mate.com/hc/en-us/requests/new";
    } else {
      if ($("#where-did-you-buy").val() == "Case-mate.com") {
        if ($("#order-id").val() == "" || $("#email-id").val() == "" || $("#product_images").val() == "" || variantid == "") {
          $(".errormsg").html("Please enter order details and upload image. Then, click &quot;Get Order Details&quot; to select product.");
          $(".errormsg").show();
          return false;
        } else {
          if (variantid == "" || variantid == null) {
            $(".errormsg").html("Please select product for warranty claim.");
            $(".errormsg").show();
            return false;
          }
        }
      } else {

        localStorage.setItem("what_buy", $("#what-did-you-buy").val());
        localStorage.setItem("where_buy", $("#where-did-you-buy").val());
        localStorage.setItem("reason_claim", $("#reason-for-claim").val());
        localStorage.setItem("country", $("#which-country").val());

        if ($("#what-did-you-buy").val() == "Phone Cases") {
          window.location.href = "/pages/retail-warranty?type=cases";
        } else if ($("#what-did-you-buy").val() == "Screen Protectors") {
          window.location.href = "/pages/retail-warranty?type=screen_protector";
        } else {
          window.location.href = "https://support.case-mate.com/hc/en-us/requests/new";
        }
      }
    }


    $.post("https://shopifywarranty.case-mate.com/fetch_order.php", {
      variantid: variantid,
      productid: productid,
      orderdate: orderdate,
      oid: $("#order-id").val(),
      customerid: customerid,
      cemail: $("#email-id").val(),
      whatdidyou: $("#what-did-you-buy").val(),
      wheredidyou: $("#where-did-you-buy").val(),
      lastname: $("#last-name").val(),
      product_images: $("#product_images").val(),
      productsku: productsku,
      producttitle: producttitle,
      productprice: productprice,
      reasonforclaim: $("#reason-for-claim").val(),
      reason: $("#reason").val(),
      claim: "yes"
    }, function (data, status) {
      console.log(data);
      // return false;
      if (data == "zendeskredirect" || data == "Excluded" || data == 0 || data == "Already" || data == "Not Eligible") {
        if (data == 0) {
          $(".errormsg").html("Selected product is out of stock. For further support, please contact our support team by clicking the Support Team link below.");
          $(".errormsg").show();
          return false;
        }
        if (data == "Already") {
          $(".errormsg").html("Warranty already claimed for this product.");
          $(".errormsg").show();
          return false;
        }
        if (data == "Not Eligible") {
          $(".errormsg").html("This product is not eligible for warranty.");
          $(".errormsg").show();
          return false;
        }
        if (data == "Excluded") {
          // $(".errormsg").html("This product is not eligible for warranty.");
          // $(".errormsg").show();
          window.location.href = "https://support.case-mate.com/hc/en-us/requests/new";
          return false;
        }

        // window.location.href = 'https://support.case-mate.com/hc/en-us/requests/new';
      }
      if (data != "invalid") {
        $("body").addClass("loading");
        $(".errormsg").html(" ");
        $(".errormsg").hide();
        var discount = data;

        $.ajax({
          type: "POST",
          url: "/cart/clear.js",
          data: "",
          dataType: "json",
          success: function () {
            setTimeout(function () {
              var refno = $("#order-id").val();
              CartJS.addItem(variantid, 1, {
                "success": function (data, textStatus, jqXHR) {
                  CartJS.setNote("Warranty Order Number: #" + refno);

                  // window.location.href = '/discount/' + data +'?redirect=/checkout';
                  setTimeout(function () {
                    // window.location.href = '/cart/'+ variantid + ':1' +'?discount=' + discount;
                    window.location.href = "/discount/" + discount + "?redirect=/checkout";
                  }, 3000);
                }
              });
            }, 2000);
          },
          error: function (XMLHttpRequest, textStatus) {
            /* error code */
          }
        });
      } else {
        alert("There is an error with your warranty claim. Please check your order number.");
        return false;
      }
    });
  });
  $("#files").on("change", function () {
    var form_data = new FormData();

    // Read selected files
    var totalfiles = document
      .getElementById("files")
      .files
      .length;
    for (var index = 0; index < totalfiles; index++) {
      form_data.append("files[]", document.getElementById("files").files[index]);
      var file1 = document.getElementById("files").files[index];
      if (file1 && file1.size > 5242880) { // 5 MB (this size is in bytes)
        $(".errormsg1").html("Please upload image below 5MB.");
        $(".errormsg1").show();
        return false;
      }
      var imgname = file1.name;
      var aex = /(\.png|\.jpeg|\.jpg)$/i;
      if (! aex.exec(imgname)) {
        $(".loader1").hide();
        $(".errormsg1").html("Invalid Image type. JPEG, JPG or PNG accepted.");
        $(".errormsg1").show();
        return false;
      }
    }


    $(".loader1").show();
    // AJAX request
    $.ajax({
      url: "https://shopifywarranty.case-mate.com/ajaxfile.php",
      type: "post",
      data: form_data,
      dataType: "json",
      contentType: false,
      processData: false,
      success: function (response) {
        console.log(response);
        if (response == "Invalid Image") {
          $(".loader1").hide();
          $(".errormsg1").html("Invalid Image type. JPEG, JPG or PNG accepted.");
          $(".errormsg1").show();
        } else {
          var imgs = "";

          for (var index = 0; index < response.length; index++) {
            var src = response[index];
            if (imgs == "") {
              imgs = src;
            } else {
              imgs = imgs + "," + src;
            }
            // Add img element in <div id='preview'>
            $("#preview").html("<img src=\"" + src + "\" style=\"width:100%;\">");
          }
          $("#product_images").val(imgs);
          $(".loader1").hide();
          $(".errormsg1").hide();
        }

      }
    });
  });

});